import { cn } from '@/lib/utils'

/**
 * Ô giữ chỗ khi đang tải. Dùng thay spinner ở mọi chỗ đã biết trước chiều
 * cao: spinner làm nội dung nhảy một nhịp khi dữ liệu về, skeleton thì không.
 */
export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded bg-rule/45', className)} aria-hidden />
}

/** Khung xương một bảng — khớp nhịp hàng của DataTable. */
export function SkeletonRows({ rows = 5, className }: { rows?: number; className?: string }) {
  return (
    <div className={cn('divide-y divide-rule/60', className)} aria-hidden>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 px-3 py-3.5">
          <Skeleton className="h-3.5 w-24" />
          <Skeleton className="h-3.5 flex-1 max-w-[32%]" />
          <Skeleton className="ml-auto h-3.5 w-16" />
        </div>
      ))}
    </div>
  )
}
